<template>
    <div
        :class="context.classes.element"
        :data-type="context.type"
    >
        <FormulateSlot
            name="prefix"
            :context="context"
        >
            <component
                :is="context.slotComponents.prefix"
                v-if="context.slotComponents.prefix"
                :context="context"
            />
        </FormulateSlot>
        <div class="formulate-input" data-classification="select">
            <div class="formulate-input-element formulate-input-element--select">
                <select v-model="documentType">
                    <option value="id_number">ID</option>
                    <option value="passport_number">Passport</option>
                    <option value="driver_license_number">Driver License</option>
                </select>
            </div>
        </div>
        <input
            v-model="documentValue"
            type="text"
            v-bind="attributes"
            @blur="context.blurHandler"
            v-on="$listeners"
            :placeholder="placeholder"
        >
        <FormulateSlot
            name="suffix"
            :context="context"
        >
            <component
                :is="context.slotComponents.suffix"
                v-if="context.slotComponents.suffix"
                :context="context"
            />
        </FormulateSlot>
    </div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";
export default {
    name: "IdentityDocument",
    data() {
        return {
            documentObject: {},
            documentType: 'id_number',
            documentValue: '',
            placeholders: {
                id_number: 'ID Number...',
                passport_number: 'Passport Number...',
                driver_license_number: 'Driver License Number...'
            }
        };
    },
    watch: {
        documentType: function(val) {
            this.documentValue = this.documentObject[val] || '';
            this.context.model = {type: val, identification: this.documentValue};
        },
        documentValue: function(val) {
            this.documentObject[this.documentType] = val;
            this.context.model = {type: this.documentType, identification: val};
        }
    },
    computed: {
        placeholder: function() {
            return this.placeholders[this.documentType];
        }
    },
    created() {
        if (this.context.model) {
            if (typeof this.context.model === "string") {
                this.documentObject = JSON.parse(this.context.model);
            }
            if (typeof this.context.model === "object") {
                this.documentObject = this.context.model;
            }
        }
        this.documentType = Object.keys(this.documentObject)[0] || 'id_number';
        this.documentValue = Object.values(this.documentObject)[0] || '';
    },
    mixins: [FormulateInputMixin]
};
</script>

<style scoped>

</style>